import React from 'react'
import Header from '../Components/Header';
import Divider from './../Images/divider.png';
import GroupImg from './../Images/group-img.png';
import DotsTheme from './../Images/dots-theme.png';
import BigImg from './../Images/big-img.png';
import SmallImg from './../Images/small-img.png';
import Footer from '../Components/Footer';

const About = () => {
    return (
        <>
            <Header />

            <div className="pt-150">
                <div className="container mb-5">
                    <div className="main-title-3 ">
                        <span className='divider'><img src={Divider} alt="" /></span>
                        <h1>Who we are</h1>
                        <p>Vistaplots is the Smart Real Estate Investment, Land Development & Property listing portal providing with
                            the access to the residential and commercial property investment and converting the Investment to the
                            purchase of the property asset after the Lock in period.</p>
                        <p> Real Estate property asset makes you wealthy with a minimum of 30% to 50% Return of the Investment (ROI)
                            year on year. Vistaplots are keener on developing the plots which yields the highest rental income
                            returns through the right market review and due diligence.
                        </p>
                    </div>
                </div>
                <div className="dots-rel">
                    <div className="container">
                        <div className="dots-theme">
                            <img src={DotsTheme} alt="" />
                        </div>
                        <div className="about-img mb-4">
                            <img src={GroupImg} alt="" />
                        </div>
                        <div className="dots-theme-2">
                            <img src={DotsTheme} alt="" />
                        </div>
                        <div className="about-img-data mb-5">
                            <div className="row">
                                <div className="col-md-3 col-6">
                                    <div className="data-details text-center">
                                        <h2>15</h2>
                                        <p>Investment Experience</p>
                                    </div>
                                </div>
                                <div className="col-md-3 col-6">
                                    <div className="data-details text-center">
                                        <h2>300+</h2>
                                        <p>Properties Funded</p>
                                    </div>
                                </div>
                                <div className="col-md-3 col-6">
                                    <div className="data-details text-center">
                                        <h2>100,000+</h2>
                                        <p>Happy Clients</p>
                                    </div>
                                </div>
                                <div className="col-md-3 col-6">
                                    <div className="data-details text-center">
                                        <h2>500</h2>
                                        <p>Dedicated Users</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container mb-70">
                    <div className="main-title-3">

                        <p>Invest in the fast-growing asset with the right property management provided by Vistaplots. At, Vistaplots we monitor your investments on the properties including the market value of the property based on the city. </p>
                        <p>There is a major increase in the real estate prices above 200% for the past decade, Which is around 10% of the Capital appreciation year on year. The Risk of Investing in Real Estates are much lower compared to the other Investments. Capital Appreciation along with the Rental Yields gives you a good dividend yields year on year (YOY).</p>
                        <p>Property prices rise happens gradually which lowers the risk factors of losing the money. Vistaplots is a superior plot development company in Bangalore working on the developing the plots in the Residential, Commercial & Industrial Segment. The Residential Project of the Plot extends 20X30 Plot, 30X40 Plot, 30X50 Plot, 30X60 Plot, 40X60 Plot, 50X60 Plot and 50X80 Plot which are best suited for the Residence and Villas Construction.
                        </p>
                        <p>
                            Vistaplots works on the mega plot development inside the townships with various sizes from 1000 Sq. Ft to 4,00,000 Sq. Ft in and around the Bangalore City. Vistaplots has several senior advisors who will be assisting the clients in the right investments on the Residential, Commercial and Industrial Plots across Bangalore & Chikkaballapur. Vistaplots will also be expanding their footsteps across the other tier1 cities of India. Vistaplots also assists the buyers to buy the Plots in the Monthly EMI’s.</p>
                        <p>Invest a minimum amount of 10,000 Rs/- in the fast-growing real estate projects of Vistaplots. The Investment can be appreciated from 40% to 100% within a time span of 18 months to 36 months of time. The Investment also can be converted to the Plot purchase with Vistaplots. Vistaplots develops the city plots with the amenities such as Club House, Parks, Open Spaces, Spine Roads, Jogging Tracks, Gyms/Exercise Stations, Kids Playground, Cricket Practise Nets, Tennis Courts, Basketball Courts, Volleyball Courts, Swimming Pool and more.</p>
                        <p>Investors can expect very high Return on the Investment (ROI) due to the surrounding growing Residential and Industrial Areas. Vistaplot is a reputed property investment and management company focusing on delivering the plots on time to the clients.

                        </p>
                    </div>
                </div>
                <div className="container mb-70">
                    <div className="main-title-3 ">
                        <span className='divider'><img src={Divider} alt="" /></span>
                        <h1>Why should you Invest in Vistaplots?</h1>
                        <p>Vistaplots has a upgraded technology platform which helps the users to understand about the assets/properties and the property appreciation. The Users get access to the top real estate properties which can provide a minimum of 10% of the Returns on the Investments (ROI). </p>
                    </div>
                </div>
                <div className="container mb-70">
                    <div className="main-title-3 ">
                        <span className='divider'><img src={Divider} alt="" /></span>
                        <h1>How do we help the Customers/Users?</h1>
                        <p>The Users can list out the Properties for Buying and Renting out for the Residential, Commercial Properties so, the Buyers and the users looking for the rental properties can access the properties through Vistaplots. </p>
                    </div>
                </div>
            </div>


            <div className="vision-bg py-50 mb-70">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="double-imgs">
                                <div className="big-img">
                                    <img src={BigImg} alt="" />
                                </div>
                                <div className="small-img">
                                    <img src={SmallImg} alt="" />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="main-title-3 mb-60">
                                <span className='divider text-start'><img src={Divider} alt="" /></span>
                                <h1 className='text-start'>Our  Vision</h1>
                                <p>Greater Analysis with the right data which is transparent for every user to understand the best performing property asset. Our Integrity with Commitment to deliver the maximum support to the Investors to make sure the users get a good return on Investment (ROI).</p>
                            </div>
                            <div className="main-title-3 ">
                                <span className='divider text-start'><img src={Divider} alt="" /></span>
                                <h1 className='text-start'>Our Mission</h1>
                                <p>With the right market analysis, we focus on building the best portfolio property/asset to our users which can provide the best Return on Investment (ROI).</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div className="container mb-70">
                    <div className="main-title-3 ">
                        <span className='divider'><img src={Divider} alt="" /></span>
                        <h1>Our Vistaplot Technology Platform</h1>
                        <p>Get to understand the A Grade Residential, Commercial, Industrial Properties with our Vistaplot tech platform. Get to know the properties which has around 6% to 20% Return on the Investment (ROI) Year on Year. </p>
                    </div>
                </div>
            </div>
            <div className="vision-bg py-60 mb-70">
                <div className="container">
                    <div className="row">
                        
                        <div className="col-lg-6">
                            <div className="main-title-3 pe-4">
                                <span className='divider text-start'><img src={Divider} alt="" /></span>
                                <h1 className='text-start'>Why should you Invest in the Property Assets with Vistaplots?</h1>
                                <p>Vistaplots team takes the complete care and understanding every detail and the metric of the property including the rental returns, location of the property, quality of the land, capital appreciation along with the market value and other major indicators which will aim to improve the property value within 18 to 36 months of the time in which the Investment of the User matures.<br/> 
Users will be assigned to specific expert advisor who can guide the user to Invest in the Properties from Vistaplots. The Property/Asset Management team from the Vistaplots will be working on the legalities of the plots/projects. <br/>
Our Users/Customers can be supported with the call support from our Telecare executive who can guide you and answer your initial questions. Every New listing on the Property for the Investment will be notified to the Users through Mail Communication.
</p>
                            </div>
                           
                        </div>
                        <div className="col-lg-6">
                            <div className="double-imgs ps-30">
                                <div className="big-img">
                                    <img src={BigImg} alt="" />
                                </div>
                                <div className="small-img">
                                    <img src={SmallImg} alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div className="container mb-70">
                    <div className="main-title-3 ">
                        <span className='divider'><img src={Divider} alt="" /></span>
                        <h1>Commercial or Residential Investment</h1>
                        <p>Users can Invest either in the Commercial or Residential Asset class of Vistaplots, Commercial Investments have more growth and 83% Mark to Market potential compared to the Residential Investment. The Commercial Real Estate is the best performing asset in our country. With several the Corporate Companies entering in India, The Value of the Commercial Office Spaces have really hiked up. </p>
<p>Our Commercial Property management team does the right property/plot identification, due diligence before finalizing the plot for development by Vistaplots.  We, At Vistaplots look at the clear title where the property does not have any kinds of the risks. Our Team also has legal experts who can do the complete background check and the due diligence of the plot/property so the user can be risk free in all the aspects of the property. </p>
<p>At Vistaplots, We ensure that there is no litigation in the plots/property and there are no disputes between the owner and the Individual, the owner and any of the company Etc. We also have our Technical due diligence team to check whether the property is best suited for every construction. Our Vistaplot provides the user with the complete integrity and transparency to the user on every detail of the plot and also on the Investments made on the Residential Property/Asset, Commercial Property/Asset & Industrial Property/Asset. 
</p>
                    </div>
                </div>
            </div>
            <Footer/>
        </>
    )
}

export default About